// @flow
import ContactList from 'components/contact/ContactList';
import { connect } from 'react-redux';

import type { StateProps } from 'components/contact/ContactList';
import type { StateType } from 'types/Actions';

import { withRouter } from 'react-router-dom';

export default withRouter(
  connect((state: StateType): StateProps => ({
    themes: state.faqState.themes,
    questions: state.faqState.questions
  }))(ContactList)
);
